export default __webpack_public_path__ + "static/topNavItems-do-2-dark-e4338abbe144e4fcfa72cd1fd56dd877.png";